import React from 'react';
import AppCrashFallback from '../../error-handling/components/web/AppCrashFallback';
/**
 * Web 端渲染崩溃兜底 UI。
 *
 * @returns {ReactElement}
 */
export function getErrorFallbackElement() {
    return React.createElement(AppCrashFallback, null);
}
